<template>
  <div class="user-menu">
    <b-dropdown position="is-bottom-left">
      <div slot="trigger" class="trigger">
        <font-awesome-icon icon="user-circle" class="user-icon" size="lg" />
        {{ currentUserInfo.accountFirstName }} {{ currentUserInfo.accountLastName }}
        <font-awesome-icon icon="chevron-down" class="user-icon" size="lg" />
      </div>

      <b-dropdown-item has-link class="menu-item" v-if="isShipper || isCarrier">
          <router-link :to="{ name: 'account-settings'}">
            <font-awesome-icon icon="user" class="menu-icon" />
            Account Settings
          </router-link>
      </b-dropdown-item>

      <b-dropdown-item has-link class="menu-item">
        <a href="#" @click.stop.prevent="toggleCompanyInvite">
          <font-awesome-icon icon="users" class="menu-icon" />
          Invite your colleagues
        </a>
      </b-dropdown-item>

      <b-dropdown-item has-link class="menu-item">
        <a href="#" @click.stop.prevent="toggleContractTruckl">
          <font-awesome-icon icon="envelope" class="menu-icon" />
          Contact Truckl
        </a>
      </b-dropdown-item>

      <hr class="dropdown-divider"/>
      <!--
      <b-dropdown-item disabled>
        <a class="is-disabled">
          <font-awesome-icon icon="building" />
          Company Profile
        </a>
      </b-dropdown-item>

      <hr class="dropdown-divider"/>
      -->

      <b-dropdown-item custom class="menu-item">
        <font-awesome-icon icon="sign-out-alt" class="menu-icon" />
        <a href="#" @click="logout"> Log out</a>
        <font-awesome-icon v-show="isLoggingOut" icon="spinner" spin />
      </b-dropdown-item>

    </b-dropdown>

    <company-invite :show.sync="showCompanyInvite" />
    <contact-truckl :show.sync="showContactTruckl" />
  </div>
</template>

<script>
import CompanyInvite from '@/components/InviteToCompanyModal'
import ContactTruckl from '@/components/ModalContactTruckl'

import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  name: 'UserMenu',

  computed: {
    ...mapState('user', ['tokens', 'currentUserInfo']),
    ...mapGetters('user', ['isFactoring', 'isShipper', 'isCarrier', 'isCompanyAdmin', 'isTrucklAdmin'])
  },

  data() {
    return {
      showCompanyInvite: false,
      showContactTruckl: false,
      isLoggingOut: false
    }
  },

  components: {
    CompanyInvite,
    ContactTruckl
  },

  methods: {
    ...mapActions('user', { _logout: 'invalidate' }),

    logout() {
      this.isLoggingOut = true
      this._logout()
    },

    toggleCompanyInvite() {
      this.showCompanyInvite = !this.showCompanyInvite
    },

    toggleContractTruckl() {
      this.showContactTruckl = !this.showContactTruckl
    }
  }
}
</script>

<style scoped>
.trigger {
  color: white;
}

.menu-item {
  width: 210px;
}

.menu-icon {
  margin-right: 5px;
}
</style>
